import React from "react";
import { Grid, Typography } from "@material-ui/core";
import { useAuth } from "components/auth-wrapper/useAuth";
import navigateTo from "utils/history";
import styles from "./LandingPage.module.scss";

export const LandingPage: React.FunctionComponent = () => {
  const { isAuthenticated } = useAuth();

  React.useEffect(() => {
    if (isAuthenticated) {
      navigateTo("/");
    }
  }, [isAuthenticated]);

  return (
    <Grid container className={styles.container}>
      <Typography variant="h6">Please login to use the app.</Typography>
    </Grid>
  );
};
